import AbstractChannel from './AbstractChannel'

export default class GlobalAirportParking extends AbstractChannel {

  name = 'global_airport_parking'
  title = 'Global Airport Parking (GAP)'
  titleShort = 'GAP'
  color = '#7f7f7f'

  supportedFeatures = ['blackouts']

}
